export const DEVICE_DEPLOYMENT_SUMMARY = {
    ACTIVE: {
        status: null, statusMessage: null,
        systemFailure: 'The device inventory is not available at the moment. Please try again later.',
        btnText: 'View devices',
        btnAction: 'manageInventory/deviceInventory',
        btnParam: {},
        fieldpermission: {
            profile: 'manageInventory.fanDeploymentProfile',
            deviceInventory: 'manageInventory.deviceInventory'
        },
        hideDeviceChart: false
    },
    INACTIVE: {
        status: null, statusMessage: null,
        systemFailure: 'The device inventory is not available at the moment. Please try again later.',
        btnText: 'View devices',
        btnAction: 'manageInventory/deviceInventory',
        btnParam: {},
        fieldpermission: {
            profile: 'manageInventory.fanDeploymentProfile',
            deviceInventory: 'manageInventory.deviceInventory'
        },
        hideDeviceChart: false
    },
    PROCESSING: {
        status: 'Processing',
        // statusMessage: 'We\'re processing your request. We\'ll email you when it\'s ready.',
        statusMessage: 'The device inventory report is not available at the moment. Please try again later.',
        btnText: 'View devices',
        btnAction: 'manageInventory/deviceInventory',
        btnParam: {},
        fieldpermission: {
            profile: 'manageInventory.fanDeploymentProfile',
            btnPermission: 'manageInventory.deviceInventory'
        },
        hideDeviceChart: false,
        hideLegend: false
    },
    FUTURE_DEPLOYMENT: {
        status: null,
        systemFailure: 'The device inventory is not available at the moment. Please try again later.',
        statusMessageHeader: 'Future Enrollment',
        statusMessage: 'Enrollment is scheduled in the future.',
        btnText: 'View devices',
        btnAction: 'manageInventory/deviceInventory',
        btnParam: {},
        fieldpermission: {
            profile: 'manageInventory.fanDeploymentProfile',
            deviceInventory: 'manageInventory.deviceInventory'
        },
        hideDeviceChart: false
    },
    NO_SETUP: {
        status: 'Set up accounts',
        statusMessage: 'Your accounts have been added. Complete the setup process to enroll your devices.',
        statusMessageZTE: 'foundation accounts have been added. Complete the setup process to enroll your devices.',
        btnText: 'Continue',
        btnAction: 'signup',
        btnParam: {},
        fieldpermission: {
            profile: 'manageInventory.fanDeploymentProfile',
            btnPermission: 'manageInventory.signup'
        },
        deviceStatusSummary: [
            {
                'status': 'READY_TO_SETUP',
                'noOfDevices': 0
            }
        ],
        hideDeviceChart: true
    },
    AWAITING_SIGNUP: {
        status: 'Add accounts',
        statusMessage: 'To enroll the devices on these accounts, add the accounts.',
        btnText: 'Add accounts',
        btnAction: 'welcome',
        //btnParam: {tab: 'awaitingSignupFanList'},
        fieldpermission: {
            profile: 'manageInventory.fanDeploymentProfile',
            btnPermission: 'manageInventory.signup'
        },
        deviceStatusSummary: [
            {
                'status': 'AWAITING_SIGNUP',
                'noOfDevices': 0
            }
        ],
        hideDeviceChart: true
    },
    NO_RESULT: {
        status: 'No Results',
        // tslint:disable-next-line:max-line-length
        statusMessage: 'To find a foundation account, you must enter the full account number. If no results are found, the account you\'re searching for may need to be added or set up.',
        btnText: null,
        btnAction: null,
        hideDeviceChart: true,
        hideLegend: true
    },
};
